import React from 'react';
import { Check, Copy } from 'lucide-react';

export function CopyableMeta({ label, value }: { label: string; value: string }) {
  const [copied, setCopied] = React.useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1200);
    } catch {
      /* clipboard unavailable */
    }
  };

  return (
    <span className="inline-flex items-center gap-1 text-app-text-subtle">
      <span>
        {label} {value}
      </span>
      <button
        type="button"
        onClick={handleCopy}
        className="p-0.5 rounded hover:bg-app-hover text-app-text-subtle hover:text-app-text-muted transition-colors"
        aria-label={`${label} kopieren`}
        title={copied ? 'Kopiert' : `${label} kopieren`}
      >
        {copied ? <Check className="w-3.5 h-3.5 text-green-600" /> : <Copy className="w-3.5 h-3.5" />}
      </button>
    </span>
  );
}
